import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-sar',
  templateUrl: './integration-apps-oscal-sar.component.html',
  styleUrls: ['./integration-apps-oscal-sar.component.css'],
})
export class IntegrationAppsOscalSarComponent implements OnInit {
  @Input() sapProfiles: any[];
  @Input() sarProfiles: any[];
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'sapProfile',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'sarProfile',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'isRlink',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'dummyRlink',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }
}
